<div class="position-reletivediv main-div-start">
  <div class="position-reletivediv popup-inner-space">
    <div class="betweenheader">Schedule Report</div>
    <div class="text-right flow-right">
      <img
        src="assets/images/close.svg"
        alt="..."
        class="img-fluid closeicon2 cursor-pointer"
        (click)="Close()"
      />
    </div>
  </div>

  <form class="width100 popup-inner-space" [formGroup]="scheduleform">
    <div class="container-data56">
      <div class="errmsg error-fix" *ngIf="errorMsg">{{errorMsg}}</div>
      <div class="sucessmsg error-fix" *ngIf="successMsg">{{successMsg}}</div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-4 mt-1">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Site Name">
            <mat-select
              formControlName="SiteId"
              (selectionChange)="OnChangeSite($event)"
            >
              <mat-option value="">(Select Site)</mat-option>
              <mat-option
                MatFormFieldControl="SiteId"
                *ngFor="let lstsite of SiteList"
                [value]="lstsite.CodeValue"
              >
                {{lstsite.CodeDisplayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.SiteId"
            >{{displayMessage.SiteId}}</span
          >
        </div>
      </div>
      <div class="col-lg-4 mt-1">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Panel Name">
            <mat-select
              formControlName="PanelId"
              (selectionChange)="OnChangePanel($event)"
            >
              <mat-option value="">(Select Location)</mat-option>
              <mat-option
                MatFormFieldControl="PanelId"
                *ngFor="let lstpanel of PanelList"
                [value]="lstpanel.CodeValue"
              >
                {{lstpanel.CodeDisplayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.PanelId"
            >{{displayMessage.PanelId}}</span
          >
        </div>
      </div>
      <div class="col-lg-4 mt-1">
        <div class="fxg-field fxg-field2">
          <mat-form-field style="display: block" title="Meter Name">
            <mat-select
              formControlName="MeterId"
              (selectionChange)="OnChangeEnergymeter($event)"
            >
              <mat-option value="">(Select Meter)</mat-option>
              <mat-option
                MatFormFieldControl="MeterId"
                *ngFor="let lstenergymeter of EnergymeterList"
                [value]="lstenergymeter.CodeValue"
              >
                {{lstenergymeter.CodeDisplayText}}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <span class="error_msg" *ngIf="displayMessage.MeterId"
            >{{displayMessage.MeterId}}</span
          >
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-2 mt-3">
        <input
          class="inputcheckbox"
          (OnChange)="scheduleform.get('IsDaily').setValue($event.checked? 'Y':'N')"
          type="checkbox"
          formControlName="IsDaily"
        />
        &nbsp;<span>Daily</span>
      </div>
      <div class="col-lg-2 mt-3">
        <input
          class="inputcheckbox"
          (OnChange)="scheduleform.get('IsWeekly').setValue($event.checked? 'Y':'N')"
          type="checkbox"
          formControlName="IsWeekly"
        />
        &nbsp;<span>Weekly</span>
      </div>
      <div class="col-lg-2 mt-3">
        <input
          class="inputcheckbox"
          (OnChange)="scheduleform.get('IsMonthly').setValue($event.checked? 'Y':'N')"
          type="checkbox"
          formControlName="IsMonthly"
        />
        &nbsp;<span>Monthly</span>
      </div>
      <div class="col-lg-2 mt-3">
        <input
          class="inputcheckbox"
          (OnChange)="scheduleform.get('IsYearly').setValue($event.checked? 'Y':'N')"
          type="checkbox"
          formControlName="IsYearly"
        />
        &nbsp;<span>Yearly</span>
      </div>
      <div class="col-lg-4 mt-1 save-cancel text-right">
        <button class="btncommon" (click)="OnSubmitScheduleReport()">
          Save
        </button>
        <button
          class="btncommon btn-border-add-company ml-24"
          (click)="Cancel()"
        >
          Cancel
        </button>
      </div>
    </div>
  </form>

  <div>
    <table class="table table-layout-fixed">
      <thead class="companytable thead-data td-data-main">
        <tr
          class="width100 popup-inner-space ng-pristine ng-invalid ng-touched"
        >
          <th class="" scope="col" style="margin-left: 10%">
            <a style="margin-left: 2%">Meter</a>
          </th>
          <th class="" scope="col"><a>Panel</a></th>
          <th class="tbl-site" scope="col"><a>Site</a></th>
          <th class="w-10" scope="col">D</th>
          <th class="w-10" scope="col">W</th>
          <th class="w-10" scope="col">M</th>
          <th class="w-10" scope="col">Y</th>
          <th class="tbl-action" scope="col">Action</th>
        </tr>
      </thead>
    </table>
  </div>
  <div class="table-scroll-schedule">
    <table class="table table-layout-fixed">
      <thead class="companytable thead-data td-data-main-shedule">
        <tr class="tr-paddingth">
          <th class="" scope="col"></th>
          <th class="" scope="col"></th>
          <th class="tbl-site" scope="col"></th>
          <th class="w-10" scope="col"></th>
          <th class="w-10" scope="col"></th>
          <th class="w-10" scope="col"></th>
          <th class="w-10" scope="col"></th>
          <th class="tbl-action" scope="col"></th>
        </tr>
      </thead>
      <tbody class="table-responsive-sechedule">
        <!--dynamic table tr start-->
        <tr *ngFor="let schedule of ScheduleData;">
          <td class="meter-td">
            <a style="margin-left: 2%">{{schedule.MeterName}}</a>
          </td>
          <td class="">{{schedule.PanelName}}</td>
          <td class="">{{schedule.SiteName}}</td>
          <td class="">
            <input
              class="inputcheckbox checkbox-center1"
              [checked]="schedule.IsDaily == 'Y'"
              type="checkbox"
              disabled
            />
          </td>
          <td class="">
            <input
              class="inputcheckbox checkbox-center2"
              [checked]="schedule.IsWeekly == 'Y'"
              type="checkbox"
              disabled
            />
          </td>
          <td class="">
            <input
              class="inputcheckbox checkbox-center3"
              [checked]="schedule.IsMonthly == 'Y'"
              type="checkbox"
              disabled
            />
          </td>
          <td class="">
            <input
              class="inputcheckbox checkbox-center4"
              [checked]="schedule.IsYearly == 'Y'"
              type="checkbox"
              disabled
            />
          </td>
          <td
            class="checkbox-center-main edit-icon"
            (click)="fillSheduleData(schedule)"
          >
            <img src="assets/images/edit.svg" class="edit-icon1" />
          </td>
        </tr>
        <!--dynamic table tr end-->
      </tbody>
    </table>
  </div>
</div>
